<template>
    <div class="main bbt-main">
        <div class="bbt-container">
            <div class="bbt-row" style="margin-left: -12px; margin-right: -12px;">
                <div class="bbt-col-xs-17" style="padding-left: 12px; padding-right: 12px;">
                    <!-- <form action="" class="search-form">
                        <input type="text" placeholder="请输入搜索关键词" class="search-form__input" v-model="searchInput">
                        <i class="bbt-icon el-icon-search" @click.enter="searchResult"></i>
                    </form> -->
                    <!-- <div class="search-total">
                        共找到 <span class="search-num">1324</span> 个结果
                    </div> -->
                    <!-- <div class="search-total">
                        <span class="bbt-tag bbt-tag--flame" v-text="searchInput" v-if="searchInput != ''"></span>
                    </div> -->
                    <!-- <div class="bbt-tab">
                        <ul class="bbt-tab__menu bbt-clearfix">
                            <li  class="active">资讯</li>
                            <li class="">快讯</li>
                            <li class="">作者</li>
                            <li class="">教程</li>
                            <li class="">文库</li>
                        </ul>
                        <div class="li-active__line" style="left: 0px; width: 32px; opacity: 1;"></div>
                    </div> -->
                    <div>
                        <div style="margin-bottom: 24px; margin-top: -8px;">
                            <div class="article-item-warp" v-for="item in articleNews" v-bind:key="item.id">
                                <div class="article-item bbt-clearfix">
                                    <div class="article-item__thumb">
                                        <el-image :src="item.imagUrl">
                                            <div slot="error" class="image-slot">
                                                <i class="el-icon-picture-outline"></i>
                                            </div>
                                        </el-image>
                                        <!-- <span class="bbt-label bbt-label--top bbt-label--rose">{{item.categoryName}}</span> -->
                                    </div>
                                        <div class="article-item__body">
                                            <h3 class="article-item__title">
                                                <router-link :to="{path:'/articleDetail/' + item.id}">
                                                    <a href="javascript:;" target="_blank" class="link-dark-major font-bold bbt-block">
                                                    {{item.title}}
                                                    </a>
                                                </router-link>
                                            </h3>
                                            <div class="article-item__content" v-html="item.content"></div>
                                            <div class="article-item__info bbt-clearfix">
                                                <div class="article-item__author">
                                                    <!-- <a href="/author/56622" target="_blank" class="">
                                                    <img src="https://cdn.8btc.com/wp-content/uploads/2018/09/56622_avatar_1536242445-64x64.png" 
                                                        class="bbt-avatar bbt-avatar--xs" 
                                                        style="margin-right:4px;"  lazy="loaded">
                                                    </a> -->
                                                    <router-link :to="{path:'/authorDetail/' + item.authorId}" target="_blank" class="link-dark-major article-item__author-name">
                                                    {{item.author}}
                                                    </router-link>
                                                    <!-- <span class="bbt-dot"></span> -->
                                                    {{item.createTime | timeInteval}}
                                                    <span v-if="item.tags.length > 0">
                                                        <a href="javascript:;" 
                                                            class="bbt-tag bbt-tag--flame  bbt-tag--sm" v-for="tag in item.tags.split(',')" v-bind:key="tag">
                                                            {{tag}}
                                                        </a>
                                                    </span>
                                                </div>
                                                <div class="article-item__data">
                                                    <span><i class="el-icon-view"></i> {{item.viewCount}}</span>
                                                </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bbt-row" style="margin-left:-12px;margin-right:-12px;">
                        <div class="bbt-col-xs-24" style="padding-left:12px;padding-right:12px;">
                            <div class="bbt-btn bbt-btn--default bbt-btn--lg bbt-btn-block" @click="loadMoreArticle" v-if="hasMoreArticle">
                                查看更多
                            </div>
                        </div>
                    </div>
                </div>

                <div class="bbt-col-xs-7" style="padding-left: 12px; padding-right: 12px;">
                    <div class="bbt-module">
                        <div class="bbt-module__header">
                            热门资讯
                            <!-- <span class="orderby-nav">
                                <span class="orderby-nav__text active">日排行</span>
                                <span class="middot">·</span>
                                <span class="orderby-nav__text">周排行</span>
                            </span> -->
                        </div>
                        <div class="article-box">
                            <div v-for="(item, index) in reArticles" :key="item.id">
                                <div :class="{'article-item':true, 'article-item--lg':true}" v-if="index == 0">
                                    <!-- <span class="bbt-label bbt-label--top bbt-label--dark">
                                        <span>热议中</span>
                                    </span> -->
                                    <div class="article-item__thumb" >
                                        <router-link :to="{path:'/articleDetail/' + item.id}">
                                            <div :style="{backgroundImage: `url(${item.imagUrl})`}"></div>
                                        </router-link>
                                    </div>
                                    <div class="article-item__body">
                                        <div class="article-item__title">
                                            <router-link :to="{path:'/articleDetail/' + item.id}" class="bbt-block link-light-major">
                                                {{item.title}}
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                                <div :class="{'article-item':true, 'article-item--small':true}" v-else>
                                    <!-- <span class="bbt-label bbt-label--top bbt-label--dark">2</span> -->
                                    <div class="article-item__thumb">
                                        <router-link :to="{path:'/articleDetail/' + item.id}">
                                            <div :style="{backgroundImage: `url(${item.imagUrl})`}"></div>
                                        </router-link>
                                    </div>
                                    <div class="article-item__body">
                                        <div class="article-item__title">
                                            <router-link :to="{path:'/articleDetail/' + item.id}" class="bbt-block link-dark-major">
                                                {{item.title}}
                                            </router-link>
                                        </div>
                                        <div class="article-item__info bbt-clearfix">
                                            <span class="article-item__info-item"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bbt-module market-module">
                        <div data-v-1042ae1c="" class="bbt-module__header">
                            热门标签
                        </div>
                        <div class="bbt-module__body">
                            <router-link :to="{path:'/search/' + item}" class="bbt-tag bbt-tag--flame" v-for="item in hotTags" v-bind:key="item">
                                {{item}}
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'SearchResult',
    props:{
        serveHost: String
    },
    data () {
        return {
            pagNo:1,
            hotTags:[],
            reArticles:[],
            articleNews:[],
            articleLoad:false,
            hasMoreArticle:true,
            articleType:0,
            categoryId:''
        }
    },
    methods: {
        loadMoreArticle:function() {
            // 文章列表更多加载
            this.pagNo++
            this.loadArticleList(this, this.pagNo, this.categoryId);
        },
        loadArticleList:function(_vm, pagNo, category) {
            //新闻列表
            $.get(_vm.serveHost + "/api/v1/article/getHatArticleTop5", {
                pagNo: pagNo,
                category: category
            }, function(r){
                if(r.code != "2000000") {
                    console.error('get articles error.');
                }
                if(r.data) {
                    r.data.forEach((item, index) => {
                        _vm.articleNews.push(item);
                    });
                    _vm.articleLoad = false;
                    _vm.hasMoreArticle = true;
                } else {
                    _vm.hasMoreArticle = false;
                    _vm.$alert('没查询到相关新闻内容', '提示', {
                        type:'warning',
                        closeOnClickModal:true,
                        closeOnPressEscape:true,
                        confirmButtonText: '确定',
                        callback: action => {
                            
                        }
                    });
                }
            });
        },
        searchResult:function() {
            this.pagNo = 1;
            this.loadArticleList(this, this.pagNo, this.categoryId);
        }
    },
    created() {
        const categoryId = this.categoryId = this.$route.params.category_id;
        // console.log(queryValue);
        var _vm = this;
        // 热门标签
        $.get(_vm.serveHost + "/api/v1/article/getHatTags", function(r){
            if(r.code != "2000000") {
                console.error('get getHatTags error.');
                return;
            } 
            _vm.hotTags = r.data;
        });
        // 热门资讯
        $.get(_vm.serveHost + "/api/v1/article/recommonderArticles", function(r){
            if(r.code != "2000000") {
                console.error('get recommonderArticles error.');
                return;
            } 
            _vm.reArticles = r.data;
        });
        this.loadArticleList(this, 1, categoryId);
    },
    watch:{
        '$route' (to, from) {
            const categoryId = this.categoryId = this.$route.params.category_id;
            this.articleNews = [];
            this.loadArticleList(this, 1, categoryId);
        }
    }
}
</script>

<style scoped>
.bbt-btn.bbt-btn--default {
    color: rgba(0,0,0,.88);
    background: #f1f1f1;
    border-color: #f1f1f1;
    transition: all .3s ease;
}
.bbt-btn.bbt-btn-block {
    display: block;
    width: 100%;
}
.bbt-btn.bbt-btn--lg {
    font-size: 14px;
    padding: 12px 18px;
    border-radius: 4px;
}
.article-item-warp:hover {
    box-shadow:0 10px 20px #ccc;
    border:1px solid #ccc;
}
.bbt-tag {
    margin-bottom: 16px;
}
.bbt-tag.bbt-tag--flame {
    color: #f46300;
    background: rgba(244,99,0,.12);
}
.bbt-tag {
    font-size: 12px;
    line-height: 20px;
    border-radius: 100px;
    padding: 3px 12px;
    margin-right: 8px;
    display: inline-block;
    transition: all .3s ease;
    font-weight: 500;
}
.article-item--small .article-item__title {
    font-size: 14px;
    line-height: 22px;
    font-weight: 700;
    height: 44px;
    overflow: hidden;
}
.article-item--small .article-item__body {
    height: 64px;
    padding-left: 8px;
    display: table-cell;
    vertical-align: top;
}
.article-item--small .article-item__thumb {
    width: 100px;
    height: 64px;
    display: table-cell;
    vertical-align: top;
}
.link-light-major {
    color: #fff;
    transition: all .3s ease;
}

.bbt-block {
    display: block;
}
.article-item--lg .article-item__title {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 8px 16px;
    margin: 8px;
    background: rgba(0,0,0,.56);
    font-size: 14px;
    line-height: 22px;
    font-weight: 700;
    border-radius: 4px;
    z-index: 2;
    transition: all .3s ease;
}
.article-item__thumb div {
    display: block;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: 50%;
    transition: all .3s ease;
}
.article-item__thumb>a {
    display: block;
    width: 100%;
    height: 100%;
}
.article-item--lg .article-item__thumb {
    width: 100%;
    height: 166px;
    display: block;
}
.article-item__thumb {
    border-radius: 4px;
    overflow: hidden;
}
.bbt-label.bbt-label--dark {
    background: rgba(0,0,0,.56);
}
.bbt-label.bbt-label--top {
    position: absolute;
    top: 8px;
    left: 0;
    z-index: 2;
}
.bbt-label {
    padding: 4px 16px 4px 8px;
    font-size: 12px;
    line-height: 20px;
    color: #fff;
    border-top-right-radius: 28px;
    border-bottom-right-radius: 28px;
}
.article-item {
    position: relative;
    margin-bottom: 24px;
}
.orderby-nav__text {
    cursor: pointer;
    transition: all .3s ease;
}
.orderby-nav .middot {
    margin: 0 6px;
}
.orderby-nav__text.active, .orderby-nav__text:hover {
    color: rgba(0,0,0,.88);
}
.orderby-nav__text {
    cursor: pointer;
    transition: all .3s ease;
}
.orderby-nav {
    padding: 4px 0;
    float: right;
    font-size: 14px;
    line-height: 22px;
    color: rgba(0,0,0,.56);
    font-weight: 400;
}
.bbt-module__header:before {
    content: "";
    width: 4px;
    height: 20px;
    position: absolute;
    top: 4px;
    left: 0;
    border-radius: 2px;
    background: #e00;
}
.bbt-module__header {
    font-size: 20px;
    line-height: 28px;
    color: rgba(0,0,0,.88);
    font-weight: 700;
    margin-bottom: 16px;
    position: relative;
    padding-left: 12px;
}
.article-item__data {
    float: right;
}
.bbt-tag.bbt-tag--flame {
    color: #f46300;
    background: rgba(244,99,0,.12);
}
.bbt-tag.bbt-tag--sm {
    padding: 4px 8px;
    line-height: 1;
}
.bbt-tag {
    font-size: 12px;
    line-height: 20px;
    border-radius: 100px;
    padding: 3px 12px;
    margin-right: 8px;
    display: inline-block;
    transition: all .3s ease;
    font-weight: 500;
}
.bbt-dot {
    width: 4px;
    height: 4px;
    display: inline-block;
    background: rgba(0,0,0,.08);
    border-radius: 50%;
    margin: 0 8px 0 4px;
    vertical-align: middle;
}
.bbt-avatar.bbt-avatar--xs {
    max-width: 24px!important;
    width: 24px!important;
    height: 24px!important;
}
.bbt-avatar {
    border-radius: 50%;
    vertical-align: middle;
}
.article-item__author {
    float: left;
}
.article-item__content em, .article-item__title em {
    color: #e00;
    font-style: normal;
}

.font-bold, .font-medium {
    font-weight: 700;
}
.link-dark-major {
    color: rgba(0,0,0,.88);
    transition: all .3s ease;
}
.bbt-block {
    display: block;
}
.article-item-warp .article-item__info {
    position: absolute;
    left: 272px;
    height:40px;
    bottom: -20px;
    right: 0;
    font-size: 1rem;
    line-height: 22px;
    color: rgba(0,0,0,.56);
}
.article-item__content {
    font-size: 14px;
    line-height: 22px;
    color: rgba(0,0,0,.56);
    max-height: 44px;
    margin-bottom: 24px;
    word-break: break-all;
    display: -webkit-box;
    box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}
.article-item__title {
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 8px;
    margin-top: 0;
    max-height: 56px;
    overflow: hidden;
}
.article-item__thumb img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    box-shadow: 0 8px 10px 1px rgba(0,0,0,.06), 0 3px 14px 2px rgba(0,0,0,.04), 0 0 5px -3px rgba(0,0,0,.08);
    transition: all .3s ease;
}
.article-item-warp .article-item__thumb {
    position: relative;
    float: left;
    margin-right: 16px;
    width: 256px;
    height: 154px;
    overflow: hidden;
    border-radius: 4px;
}
.article-item {
    position: relative;
}
.article-item-warp{
    position: relative;
    margin: 0 -16px;
    padding: 24px 16px;
    border-radius: 4px;
    transition: all .3s ease;
    border:1px solid transparent;
}
.bbt-tab__menu>li+li {
    margin-left: 34px;
}
.bbt-tab__menu>li.active {
    color: rgba(0,0,0,.88);
}
.bbt-tab__menu>li {
    font-size: 16px;
    line-height: 24px;
    color: rgba(0,0,0,.56);
    padding: 7px 0;
    float: left;
    list-style: none;
    position: relative;
    font-weight: 700;
    transition: all .3s ease;
}
.bbt-tab .li-active__line {
    height: 4px;
    position: absolute;
    left: 0;
    width: 40px;
    bottom: 2px;
    border-radius: 2px;
    background: #e00;
    transition: all .3s ease;
}
.bbt-tab__menu {
    position: relative;
}
.bbt-tab {
    position: relative;
    margin-bottom: 24px;
}
.search-total .search-num {
    color: #f46300;
    font-weight: 700;
}
.search-total {
    color: rgba(0,0,0,.56);
    margin-bottom: 16px;
}
.search-form .bbt-icon {
    position: absolute;
    top: 16px;
    right: 32px;
    font-size: 20px;
    line-height: 24px;
    color: rgba(0,0,0,.56);
    transition: all .3s ease;
}
.search-form__input {
    background: #f1f1f1;
    border-radius: 28px;
    font-size: 16px;
    line-height: 24px;
    color: rgba(0,0,0,.88);
    font-weight: 700;
    display: block;
    outline: none;
    border: none;
    padding: 16px 32px;
    width: 100%;
}
.search-form {
    position: relative;
    margin-bottom: 24px;
}
.bbt-col-xs-17 {
    float: left;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 70.83333333%;
}
.bbt-col-xs-7 {
    float: left;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 29.16666667%;
}
.main {
    margin-top: 24px;
}
.bbt-main {
    padding-bottom: 48px;
}
</style>